import { configureStore } from "@reduxjs/toolkit";

import configReducer from "./ducks/configTier";
import realtimeReducer from "./ducks/realtimeTier";
import historicalReducer from "./ducks/historicalTier";
import uiTierReducer from "./ducks/uiTier";
import customersReducer from "./ducks/customersDuck";
import authenticationReducer from "../src/Dashboard/ducks/authenticationDuck";
import trendSelectionsPersistMiddleware from "../src/store/trendSelectionsPersistMiddleware";

const store = configureStore({
  reducer: {
    config: configReducer,
    realtime: realtimeReducer,
    historical: historicalReducer,
    ui: uiTierReducer,
    customers: customersReducer,
    authentication: authenticationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(trendSelectionsPersistMiddleware),
});

export default store